import { useI18n } from '@/shared/contexts/I18nProvider';

export const TechnologyCarousel = () => {
  const { content } = useI18n();
  const { environments, technologies } = content.home.technology;
  const technologyCarouselGroups = [
    { id: 'primary', items: technologies },
    { id: 'repeat', items: technologies }
  ];

  return (
    <section className="border-b border-border-muted bg-background-primary py-14">
      <div className="mx-auto max-w-7xl px-4 text-center sm:px-6 lg:px-8">
        <p className="font-mono text-sm uppercase tracking-[0.24em] text-text-muted">
          {content.home.technology.benefitsTitle}
        </p>

        <div
          className="technology-carousel mt-8"
          aria-label={`${content.home.technology.benefitsAriaLabel}: ${technologies.join(', ')}`}
        >
          <div className="technology-carousel__track" aria-hidden="true">
            {technologyCarouselGroups.map(group => (
              <div key={group.id} className="technology-carousel__group">
                {group.items.map(technology => (
                  <span
                    key={`${technology}-${group.id}`}
                    className="rounded-full border border-border-primary bg-background-card/80 px-5 py-2 font-mono text-sm text-text-secondary shadow-sm shadow-shadow"
                  >
                    {technology}
                  </span>
                ))}
              </div>
            ))}
          </div>
        </div>

        <div className="mx-auto my-9 h-px max-w-4xl bg-border-muted" />

        <p className="font-mono text-sm uppercase tracking-[0.24em] text-text-muted">
          {content.home.technology.environmentsTitle}
        </p>

        <div className="mt-7 flex flex-wrap items-center justify-center gap-x-10 gap-y-4 font-mono text-sm text-text-secondary">
          {environments.map(companyEnvironment => (
            <span key={companyEnvironment}>{companyEnvironment}</span>
          ))}
        </div>
      </div>
    </section>
  );
};
